import React from "react";
import { programPaymenAcademy } from "../../../shared/services";
import { Resolver, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProgramPaymentType } from "../../../types/dto/program";
import useProgramStudent from "../../academyProgramDetail/hooks/students/useProgramStudent";
import { message } from "antd";
import moment from "moment";
import {
  PAYMENT_CONCEPTS,
  isSupplementalPaymentConcept,
} from "../../../shared/utils/academyPaymentConcepts";

export interface UseProgramStudentProps {
  userId: number;
  setOpenModal: (val: boolean) => void;
  onSuccess?: () => void;
}

export default function useCreatePayStudentProgramFromStudentView({
  userId,
  setOpenModal,
  onSuccess,
}: UseProgramStudentProps) {
  const { control, handleSubmit: onSubmit, reset, watch, setValue } = useForm<
    ProgramPaymentType & { payment_concept: string }
  >({
    defaultValues: {
      payment_concept: PAYMENT_CONCEPTS.CUOTA,
    },
    resolver: yupResolver(
      yup.object({
        program_id: yup.string().required("Campo requerido"),
        payment_concept: yup.string().required("Campo requerido"),
        program_payment_schedule_id: yup.mixed().when("payment_concept", {
          is: PAYMENT_CONCEPTS.CUOTA,
          then: (schema) => schema.required("Campo requerido"),
          otherwise: (schema) => schema.notRequired().nullable(),
        }),
        amount: yup.string().required("Campo requerido"),
        payment_date: yup.string().required("Campo requerido"),
      })
    ) as unknown as Resolver<ProgramPaymentType & { payment_concept: string }>,
  });

  const programIdNew = watch("program_id");

  const [loading, setLoading] = React.useState(false);
  const { getStudentsByUserIdAndProgramId } = useProgramStudent({
    program_id: +programIdNew!,
    user_id: userId,
  });

  const handleSubmit = onSubmit(async (data) => {
    if (loading) return;
    setLoading(true);

    try {
      const dataProgramStudent = await getStudentsByUserIdAndProgramId();

      if (!dataProgramStudent?.length) {
        message.error(
          "Acción no permitida, primero debes inscribir al estudiante en el programa"
        );
        return;
      }

      const concept = data.payment_concept || PAYMENT_CONCEPTS.CUOTA;
      const isSupplemental = isSupplementalPaymentConcept(concept);

      await programPaymenAcademy.create({
        program_student_id: dataProgramStudent[0]?.id,
        program_payment_schedule_id: isSupplemental
          ? null
          : +data.program_payment_schedule_id!,
        program_id: +data.program_id,
        user_id: userId,
        amount: +data.amount,
        payment_concept: concept,
        payment_date: moment(data.payment_date).toISOString(),
      });

      message.success("Se ha creado con éxito el pago del estudiante");
      setOpenModal(false);
      reset();
      onSuccess?.();
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : "Error al crear el pago";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  });

  return {
    control,
    loading,
    handleSubmit,
    watch,
    setValue,
  };
}
